import { BlurView } from 'expo-blur'
import { StyleSheet, View } from 'react-native'

import { GlassView } from '../native/glassEffect'
import type { BackdropBlurRenderer } from './FlowSheet'

// The design's layer blur of 90 on expo-blur's 0–100 scale.
const BLUR_INTENSITY = 90
// Concentric with the device's own corner, so a full-bleed slab meets the
// screen edge without a seam.
const CORNER_RADIUS = 65
// Opaque: the glass blends it with what it refracts, and a translucent tint
// stacked with the blur into a flat panel.
const GLASS_TINT = 'rgba(0, 0, 0, 1)'

/**
 * The material under every translucent flow surface: a dark blur of the host
 * app with iOS 26 Liquid Glass refracting through it where the binary links the
 * SDK's pod. Elsewhere the blur stands alone and the surface paints its fill.
 */
export function SheetMaterial({ tint = GLASS_TINT }: { tint?: string }) {
  return (
    <View style={[StyleSheet.absoluteFill, styles.slab]} pointerEvents="none">
      <BlurView
        intensity={BLUR_INTENSITY}
        tint="systemUltraThinMaterialDark"
        experimentalBlurMethod="dimezisBlurView"
        style={[StyleSheet.absoluteFill, styles.blur]}
      />
      {GlassView ? (
        <GlassView
          glassEffectStyle="clear"
          colorScheme="dark"
          tintColor={tint}
          concentricCorners
          concentricMinimumRadius={CORNER_RADIUS}
          style={StyleSheet.absoluteFill}
        />
      ) : null}
    </View>
  )
}

export const renderSheetMaterial: BackdropBlurRenderer = () => <SheetMaterial />

const styles = StyleSheet.create({
  slab: { borderRadius: CORNER_RADIUS },
  blur: { borderRadius: CORNER_RADIUS, overflow: 'hidden' },
})
